import { updateStickyCalculations } from './../initilizers/sticky';

document.addEventListener('DOMContentLoaded', () => {

    const allGridListControlGroups = document.querySelectorAll('.js-grid-list-view-controls');

    allGridListControlGroups.forEach(group => {

        const gridBtn = group.querySelector('.js-btn-grid');
        const listBtn = group.querySelector('.js-btn-list');

        const targetId = group.getAttribute('data-target');
        const defaultView = group.getAttribute('data-default') || 'grid';
        const targetContainer = document.querySelector(targetId);

        if (!targetContainer || !gridBtn || !listBtn) return;

        /**
         * Helper Function: Applies the view state
         * Handles both the Container classes and the Button active states.
         * @param {string} viewType - 'grid' or 'list'
         */
        const applyView = (viewType) => {
            if (viewType === 'list') {
                // Update Container
                targetContainer.classList.add('list-view');
                targetContainer.classList.remove('grid-view');
                // Update Buttons
                listBtn.classList.add('active');
                gridBtn.classList.remove('active');
            } else {
                // Update Container
                targetContainer.classList.add('grid-view');
                targetContainer.classList.remove('list-view');
                // Update Buttons
                gridBtn.classList.add('active');
                listBtn.classList.remove('active');
            }
        };

        applyView(defaultView);

        listBtn.addEventListener('click', () => {
            applyView('list');
        });

        gridBtn.addEventListener('click', () => {
            applyView('grid');
        });
    });

    $('.js-grid-list-view-controls[data-target="#products"] button').on('click', () => {
        setTimeout(() => {
            updateStickyCalculations();
        }, 50);
    });
});

